import _ from 'lodash'
import Audio from './audio'
import {getListedTracks, getFreeAlbumID, getAllSortedTracks, getAllOuttakes, getAllOuttakeTracks, getAllFriendsAndFamilyTracks, getAllFriendsAndFamilyItems} from '../../drawer-items'
import {isFreeUser, hasNotUnlimitedAccess} from '../../user'
import { loadPlayingTrack } from '../../actions/tracks'

let currentPlaylist = null
let currentIndex = null
let listeners = []
let isEmbed   = false;

const itemsForUsersWithUnlimitedAccess = (items) => {
    return items.filter(item => {
        let {album = {}} = item;
        return !hasNotUnlimitedAccess(item.excludeFreeAndClassicSubscription || (album && album.excludeFreeAndClassicSubscription));
    })
}
const showUnlimitedAccessMessage = ({excludeFreeAndClassicSubscription = false, album = {}}) => {
    if(hasNotUnlimitedAccess(excludeFreeAndClassicSubscription || (album && album.excludeFreeAndClassicSubscription)))
        window.unlimitedAccedV2();
}
class Manager {
  constructor() {
    this.onNext = this.onNext.bind(this);
    this.currentRequestId = 0; // Add this
    Audio.onTrackSelect(this.onNext);
  }
  onNext(idx) {
    currentIndex = idx;
    const state = idx === -1 ? "STOPPED" : "WILLPLAY";

    if (state === "STOPPED") {
      for (let cb of listeners) cb({ state });
      return;
    }

    let atStart = idx === 0;
    let atEnd = idx === currentPlaylist.length - 1;
    let track = currentPlaylist[idx];
    for (let cb of listeners) cb({ state, track, atStart, atEnd });
  }
  addListener(listener) {
    listeners.push(listener);
  }
  removeListener(listener) {
    listeners = listeners.filter((it) => it !== listener);
  }
  prevNextDisabled(isRegularEmbed = false) {
    let idx = currentIndex;
    if (!currentPlaylist || idx === null || idx === -1) {
      if (isRegularEmbed) {
        return { prevDisabled: true, nextDisabled: true };
      }
      return { prevDisabled: true, nextDisabled: true };
    }
    let atStart = idx === 0;
    let atEnd = idx === currentPlaylist.length - 1;
    return { prevDisabled: atStart, nextDisabled: atEnd };
  }
  currentTrack() {
    if (currentIndex === null || currentPlaylist === null) return null;
    return currentPlaylist[currentIndex];
  }
  currentPlaylist() {
    if (currentPlaylist === null) return null;
    return currentPlaylist;
  }
  playTrack(track) {
    this.currentRequestId++;
    const requestId = this.currentRequestId;

    const currentTrack = this.currentTrack();
    if (currentTrack && currentTrack.id === track.id) {
      if (Audio.isPlaying && Audio.isPlaying()) {
        Audio.pause();
      } else {
        Audio.play();
      }
      return;
    }

    const concertAlbum = {
      tracks: [track],
      type: "concert",
      id: `concert_${track.id}`,
      isConcert: true,
    };

    this._playItemInItems(track, [track], concertAlbum, null, requestId);
  }
  _filterItems(tracks, embed) {
    if (!tracks || !Array.isArray(tracks)) {
      return [];
    }
   
    let items = _.filter(tracks, (track) => track && track.orastream);
    if (isFreeUser() && !embed) {
      const beforeFreeFilter = items?.length;
      items = _.filter(items, "free");
    }
    return items;
  }
  playFromTrackChronologically(track) {
    this._playItemInItems(track, this._filterItems(getListedTracks()));
  }
  playFromTrackInOuttakes(track) {
    this.currentRequestId++;
    const requestId = this.currentRequestId;
    const tracks = this._filterItems(getAllOuttakeTracks());
    this._playItemInItems(track, tracks, null, null, requestId);
  }
  playFromTrackInFriendsAndFamily(track) {
    this.currentRequestId++;
    const requestId = this.currentRequestId;
    const tracks = this._filterItems(getAllFriendsAndFamilyTracks());
    this._playItemInItems(track, tracks, null, null, requestId);
  }
  playFromAlbumInCabinet(track, album, cabinetMode, tracksField = 'tracks') {
    this.currentRequestId++;
    const requestId = this.currentRequestId;

    // Get all cabinet items (albums + individual tracks) sorted by releaseDate
    const allCabinetItems = cabinetMode === 'outtakes' ? getAllOuttakes() : getAllFriendsAndFamilyItems();

    // Find the album's position in the cabinet
    const albumIdx = allCabinetItems.findIndex(item => item.isAlbum && item.id === album.id);

    // Build tracks from items that come after the album in the cabinet
    const itemsAfterAlbum = albumIdx >= 0 ? allCabinetItems.slice(albumIdx + 1) : [];
    const tracksAfterAlbum = [];
    itemsAfterAlbum.forEach(item => {
      if (item.isAlbum) {
        tracksAfterAlbum.push(...this._filterItems(item.tracks || []));
      } else if (item.isTrack) {
        tracksAfterAlbum.push(...this._filterItems([item]));
      }
    });

    // Album's playable tracks from the selected track onwards
    const albumTracks = this._filterItems(album[tracksField] || album.tracks || []);
    const startIdx = albumTracks.findIndex(t => t.id === track.id);
    const albumTracksFromHere = startIdx >= 0 ? albumTracks.slice(startIdx) : albumTracks;

    if (!albumTracksFromHere.length) return;

    const combined = [...albumTracksFromHere, ...tracksAfterAlbum];
    this._playItemInItems(albumTracksFromHere[0], combined, album, null, requestId);
  }
  playTrackInMiddle(track, showAreYouStillListeningModal) {
    this.currentRequestId++;
    const requestId = this.currentRequestId;

    const tracks = this._filterItems(getListedTracks(track));
    this._playItemInMiddleItems(
      track,
      tracks,
      null,
      showAreYouStillListeningModal,
      requestId
    );
  }
  isShowAreYouStillListeningModal() {
    return Audio.isShowAreYouStillListeningModal();
  }
  isPrevOrNext() {
    return Audio.isPrevOrNext();
  }
  play() {
    Audio.play();
  }
  pause() {
    Audio.pause();
  }
  stopPlaying() {
    Audio.stopPlaying();
  }
  playFromTrackOnAlbum(track, album, field = "tracks", embed) {
    this.currentRequestId++;
    const requestId = this.currentRequestId;



    if (!track.id && track.trackId) {
      track.id = track.trackId;
    }

    if (field === "outtakeTracks") {
      track.outTake = true;
    }

    let trackList = album[field] || [];
    if (field === "outtakeTracks") {
      trackList = album["outtakeTracks"] || [];
     
    }

    if (embed) isEmbed = embed;

    let idx = _.findIndex(trackList, (item) => item.id === track.id);

    if (
      idx < 9 &&
      album.id &&
      album.id.toLowerCase() === "a_012" &&
      field === "tracks"
    ) {
      let items = this._filterItems(album.tracks);
      items.pop();
      items.pop();
      this._playItemInMiddleItems(track, items, album, null, requestId);
    } else if (!track.demo && !track.outTake && album.type === "album") {
      const allTracks = getAllSortedTracks();
      this._playItemInMiddleItems(track, this._filterItems(allTracks), album, null, requestId);
    } else {
      
      
      const originalFree = track.free;
      
      
      const trackCopy = { ...track, free: true };
      
    
      const filteredTracks = this._filterItems(trackList);
 

      if (filteredTracks.length === 0) {
       
        return;
      }

     
      this._playItemInMiddleItems(track, filteredTracks, album, null, requestId);
    }
  }
  playAlbum(album, embed) {
    this.currentRequestId++;
    const requestId = this.currentRequestId;

    if (!album || !album.tracks || !Array.isArray(album.tracks)) {
      return;
    }

    let items = this._filterItems(album.tracks, embed);

    if (!items.length) {
      return;
    }
    
    if (embed) isEmbed = embed;
    if (album.id && album.id.toLowerCase() === "a_012") {
      //skip the last two tracks for Harvest per N request
      // items.pop()
      // items.pop()
    }

    if (album.type === "concert" || album.isConcert) {
      this._playItemInItems(items[0], items, album, null, requestId); // Pass requestId
      return;
    }

    if (album.type === "album") {
      const allTracks = getAllSortedTracks();
      if (!allTracks || allTracks.length === 0) {
        this._playItemInItems(items[0], items, album, null, requestId);
        return;
      }
      this._playItemInMiddleItems(
        items[0],
        this._filterItems(allTracks),
        album,
        null,
        requestId
      );
      return;
    }
    this._playItemInItems(items[0], items, album, null, requestId); // Pass requestId
  }
  resumePlayback(isInitial, isMp3 = false) {
    if (!this._playlists) return;
    let next = this._playlists.shift();
    if (next) {
      currentPlaylist = next;
      currentIndex = 0;
      if (!isMp3) Audio.playItems(next, 0, isInitial);
      this.onNext(0);
    }
  }
  _playItemInItems(
    track,
    items,
    album,
    showAreYouStillListeningModal,
    requestId
  ) {
    if (requestId && requestId !== this.currentRequestId) {
      return;
    }

    Audio.setShowAreYouStillListeningModal(showAreYouStillListeningModal);

    // Check if user has access before proceeding
    const trackExcluded = track.excludeFreeAndClassicSubscription || (track.album && track.album.excludeFreeAndClassicSubscription);
    if (hasNotUnlimitedAccess(trackExcluded)) {
      showUnlimitedAccessMessage(track);
      return;
    }

    loadPlayingTrack(track);
    let { id, mp3audio } = track;
    let idx = _.findIndex(items, (item) => {
      return item.id === id;
    });

    if (idx !== -1) {
      if (requestId && requestId !== this.currentRequestId) {
        return;
      }

      Audio.stopPlaying();

      const itemsToPlay = itemsForUsersWithUnlimitedAccess(items.slice(idx));
      const isFreeAlbum = album && album.id === getFreeAlbumID();
      let allowedPlaylistLength =
        isFreeUser() && !isFreeAlbum ? 1 : items.length;

      if (isEmbed) {
        allowedPlaylistLength = items.length;
      }
      this._playlists = _.chunk(itemsToPlay, allowedPlaylistLength);

      setTimeout(() => {
        // Check again if this request is still valid
        if (requestId && requestId !== this.currentRequestId) {
          return;
        }

        this.resumePlayback(true, mp3audio);

        if (requestId && requestId !== this.currentRequestId) {
          return;
        }

        Audio.play();
      }, 100);
    } else {
      console.error("Track not found in items array:", track.id);
    }
  }
  _playItemInMiddleItems(track, items, album, showAreYouStillListeningModal, requestId) {
    if (requestId && requestId !== this.currentRequestId) {
      console.log("Request cancelled due to newer request");
      return;
    }

    if (!items) {
      console.error("No items provided to _playItemInMiddleItems");
      return;
    }
    
    if (!items.length) {
      console.error("Empty items array provided to _playItemInMiddleItems");
      return;
    }


    Audio.setShowAreYouStillListeningModal(showAreYouStillListeningModal);

    // Check if user has access before proceeding
    const trackExcluded = track.excludeFreeAndClassicSubscription || (track.album && track.album.excludeFreeAndClassicSubscription);
    if (hasNotUnlimitedAccess(trackExcluded)) {
      showUnlimitedAccessMessage(track);
      return;
    }

    let { id } = track;
    loadPlayingTrack(track);
    let idx = _.findIndex(items, (item) => {
      return item.id === id;
    });
    if (!track?.demo && !track?.outTake && album?.type === "album") {
      const trackOrderId = `${album.id}_${track.id}`;
      idx = _.findIndex(items, (item) => {
        return item.trackOrderId === trackOrderId;
      });
    }
    if (idx !== -1) {
      if (requestId && requestId !== this.currentRequestId) {
        return;
      }

      const freeTracks = items.filter((item) => item.free);

      const itemsToPlay = isFreeUser()
        ? freeTracks
        : itemsForUsersWithUnlimitedAccess(items);
      if (_.isElement(itemsToPlay)) return;
      
      if (!itemsToPlay || !itemsToPlay.length) {
        console.error("No playable items after filtering");
        return;
      }

      let playableIdx = _.findIndex(itemsToPlay, (item) => item.id === id);
      if (!track?.demo && !track?.outTake && album?.type === "album") {
        const trackOrderId = `${album.id}_${track.id}`;
        playableIdx = _.findIndex(itemsToPlay, (item) => {
          return item.trackOrderId === trackOrderId;
        });
      }
      if (playableIdx === -1) {
        console.error("Track not found in playable items. Track ID:", track.id, "Album:", album?.id);
        return;
      }

      if (requestId && requestId !== this.currentRequestId) {
        return;
      }

      this._playlists = [itemsToPlay];
      currentPlaylist = itemsToPlay;
      currentIndex = playableIdx;
      Audio.playItems(itemsToPlay, playableIdx, false);
      this.onNext(playableIdx);

      setTimeout(() => {
        if (requestId && requestId !== this.currentRequestId) {
          return;
        }
        Audio.play();
      }, 500);
    }
  }
}
export default new Manager()